import { FormikErrors } from 'formik';
import React from 'react';
import { TbAlertTriangleFilled } from 'react-icons/tb';

interface ErrorProps {
  error?: string | FormikErrors<any> | string[] | FormikErrors<any>[];
}

const Error: React.FC<ErrorProps> = ({ error }) => {
  if (!error) {
    return null;
  }

  return (
    <div className="mt-2 text-red-800 flex items-center gap-1 font-normal">
      <>
        <TbAlertTriangleFilled size={16} /> {error}
      </>
    </div>
  );
};

export default Error;
